enum MergeIngredientType {
  Ingredient1 = 1,
  Ingredient2 = 2,
  MergeIngredient = 3,
}
enum MergeStockType {
  Stock1 = 1,
  Stock2 = 2,
  MergeStock = 3,
}

enum IngredientsModalType {
  Vendor = 'Vendor',
  IngredientType = 'IngredientType',
  LiquidClass = 'LiquidClass',
  ProteinType = 'ProteinType',
}

export const IngredientsModalDisplayNames: Record<IngredientsModalType, string> = {
  [IngredientsModalType.Vendor]: 'Vendor',
  [IngredientsModalType.IngredientType]: 'Ingredient Type',
  [IngredientsModalType.LiquidClass]: 'Liquid Class',
  [IngredientsModalType.ProteinType]: 'Protein Type',
};

export { MergeIngredientType, MergeStockType, IngredientsModalType };
